import { getMembershipAvailable, getSubscriptionAvailable, postUseMembership, postUseSubscription } from "src/api/product";
/**
 * 상품 담기.
 *
 * 구독은 `subscriptionId` 단일 필드를, 이용권은 멤버십 맵을 받는다.
 * 응답은 둘 다 `{ licenseIds }` 라 성공·실패 처리는 호출부에서 공유한다.
 */ export const requestProductUse = (param)=>{
    let { entitlement , productIds , choicePurchaseOption  } = param;
    return entitlement.type === "subscription" ? postUseSubscription({
        subscriptionId: entitlement.id,
        productIds,
        choicePurchaseOption
    }) : postUseMembership({
        membershipId: entitlement.id,
        productIds,
        choicePurchaseOption
    });
};
/** 두 API 응답의 항목 형태 차이를 흡수해 상품 단위 판정만 남긴다 */ const normalize = (data)=>data.map((param)=>{
        let { productId , usable , unUsableReasons  } = param;
        return {
            productId: String(productId),
            usable,
            unUsableReasons
        };
    });
/**
 * 담기 전 사용 가능 여부 사전 판정 (연관자료 흐름 전용).
 *
 * 응답 구조가 갈린다 — 이용권은 항목마다 `membershipId` 가 붙고, 구독은 `subscriptionId` 가
 * 응답 최상위에 온다. 어느 수단의 판정인지는 호출부가 이미 알고 있으므로 버리고,
 * 상품 단위 판정만 남겨 반환한다.
 *
 * `choicePurchaseOption` 은 구독에만 보낸다. 이용권 쪽 `membership-available` 은 예전부터
 * 이 값을 싣지 않아, 다운로드로 담을 때 판정과 실제 담기가 어긋날 수 있다 (plan.md §4.2 후속 과제).
 */ export const requestProductAvailability = async (param)=>{
    let { entitlement , productIds , choicePurchaseOption  } = param;
    if (entitlement.type === "subscription") {
        const { data  } = await getSubscriptionAvailable({
            subscriptionId: entitlement.id,
            productIds,
            choicePurchaseOption
        });
        return normalize(data);
    }
    const { data  } = await getMembershipAvailable({
        membershipId: entitlement.id,
        productIds
    });
    return normalize(data);
};
/**
 * 구독이 무효(만료·결제 실패)라 담을 수 없는 경우의 사유 코드.
 *
 * `string[]` 으로 두는 이유 — 비교 대상인 `ProductAvailability.unUsableReasons` 가 `string[]` 이다.
 * 이용권(`membership-available`)이 코드를 주는지 한글 문구(`UnUsableReason`)를 주는지 확인되지
 * 않아 공용 타입을 좁힐 수 없다. `satisfies` 로 코드 오타만 막는다.
 */ const SUBSCRIPTION_INVALID_REASONS = [
    "SUBSCRIPTION_EXPIRED",
    "SUBSCRIPTION_PAYMENT_FAILED"
];
/**
 * "구독이 무효라 전부 막힌" 판정인지.
 *
 * 이 경우 이용 불가 자료를 골라 보여주는 안내는 맞지 않는다 — 자료의 문제가 아니라
 * 수단의 문제라서, 어떤 자료를 빼도 담기지 않는다. 결제 안내로 보내야 한다.
 */ export const isSubscriptionInvalidResult = (availabilities)=>availabilities.length > 0 && availabilities.every((item)=>!item.usable && item.unUsableReasons.some((reason)=>SUBSCRIPTION_INVALID_REASONS.includes(reason)));
